import { Flex } from 'antd'
import ClassName from 'clsx'
import Styles from './style.module.scss'

interface Props {
  image: string
  children: React.ReactNode
  className: string
  mask: boolean
  [key: string]: any
}

export default function FullScreenBanner({ image, children, className, mask, ...otherProps }: Partial<Props>) {
  if (!children)
    return (
      <div
        className={ClassName(Styles.container, mask && Styles.mask, className)}
        style={{ background: `url(${image}) no-repeat center/cover` }}
        {...otherProps}
      />
    )

  return (
    <Flex
      align='center'
      justify='center'
      className={ClassName(Styles.container, mask && Styles.mask, className)}
      style={{ background: `url(${image}) no-repeat center/cover` }}
      {...otherProps}
    >
      {children}
    </Flex>
  )
}
